import { render, staticRenderFns } from "./OverviewDelivery.vue?vue&type=template&id=2afa6c35&"
import script from "./OverviewDelivery.vue?vue&type=script&lang=js&"
export * from "./OverviewDelivery.vue?vue&type=script&lang=js&"
import style0 from "./OverviewDelivery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports